/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Rag_Knowledge_Assistants_Execute_Detail7Inputs */

const en_svc_rag_knowledge_assistants_execute_detail7 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build the pipeline, tune retrieval against real questions.`)
};

const ar_svc_rag_knowledge_assistants_execute_detail7 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ابنِ خط الأنابيب واضبط الاسترجاع على أسئلة حقيقية.`)
};

const bn_svc_rag_knowledge_assistants_execute_detail7 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`পাইপলাইন বানান, আসল প্রশ্নে রিট্রিভাল টিউন করুন।`)
};

const de_svc_rag_knowledge_assistants_execute_detail7 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pipeline bauen, Retrieval an echten Fragen abstimmen.`)
};

const es_svc_rag_knowledge_assistants_execute_detail7 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Construir el pipeline, ajustar la recuperación con preguntas reales.`)
};

const fr_svc_rag_knowledge_assistants_execute_detail7 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Construisez le pipeline, réglez la récupération sur de vraies questions.`)
};

const pt_svc_rag_knowledge_assistants_execute_detail7 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Construa o pipeline, afine a recuperação com perguntas reais.`)
};

const zh_svc_rag_knowledge_assistants_execute_detail7 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搭建管道，用真实问题调优检索。`)
};

const tr_svc_rag_knowledge_assistants_execute_detail7 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hattı kurun, getirmeyi gerçek sorularla ayarlayın.`)
};

const ru_svc_rag_knowledge_assistants_execute_detail7 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Постройте пайплайн, настройте поиск на реальных вопросах.`)
};

const pl_svc_rag_knowledge_assistants_execute_detail7 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zbuduj potok, dostrój wyszukiwanie na prawdziwych pytaniach.`)
};

/**
* | output |
* | --- |
* | "Build the pipeline, tune retrieval against real questions." |
*
* @param {Svc_Rag_Knowledge_Assistants_Execute_Detail7Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_rag_knowledge_assistants_execute_detail7 = /** @type {((inputs?: Svc_Rag_Knowledge_Assistants_Execute_Detail7Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Rag_Knowledge_Assistants_Execute_Detail7Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_rag_knowledge_assistants_execute_detail7(inputs)
	if (locale === "bn") return bn_svc_rag_knowledge_assistants_execute_detail7(inputs)
	if (locale === "de") return de_svc_rag_knowledge_assistants_execute_detail7(inputs)
	if (locale === "es") return es_svc_rag_knowledge_assistants_execute_detail7(inputs)
	if (locale === "fr") return fr_svc_rag_knowledge_assistants_execute_detail7(inputs)
	if (locale === "pt") return pt_svc_rag_knowledge_assistants_execute_detail7(inputs)
	if (locale === "zh") return zh_svc_rag_knowledge_assistants_execute_detail7(inputs)
	if (locale === "tr") return tr_svc_rag_knowledge_assistants_execute_detail7(inputs)
	if (locale === "ru") return ru_svc_rag_knowledge_assistants_execute_detail7(inputs)
	if (locale === "pl") return pl_svc_rag_knowledge_assistants_execute_detail7(inputs)
	return en_svc_rag_knowledge_assistants_execute_detail7(inputs)
});
export { svc_rag_knowledge_assistants_execute_detail7 as "svc_rag-knowledge-assistants_EXECUTE_detail" }